
import { reactive, watch, computed, onBeforeMount } from '@vue/composition-api'
import * as apiGuide from '@/api/guide'
import * as _ from 'lodash'
import { isSp, isPc } from '@/util/common'

export const GuideSearch = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { guide } = store.state

  onBeforeMount(() => {
    state.keyword = store.getters['guide/keyword']
  })

  const state = reactive({
    keyword: '',
    visibleSearchDetail: false // 詳細検索ウィンドウ表示フラグ
  })

  watch(() => guide.search.keyword, (now, old) => {
    state.keyword = now
  })

  const action = {
    search: () => {
      const path = isPc() ? '/pc/guide-list' : '/sp/guide-list'
      store.dispatch('guide/setKeyword', state.keyword)
      store.dispatch('guide/pageReset')
      store.dispatch('guide/setCurrentId', null)
      const { history: { current: { fullPath } } } = router
      if (path !== fullPath) {
        router.push({ path: path })
      }
      action.load()
      context.emit('search')
    },
    load: () => {
      store.dispatch('guide/search', true)
      const countParams = store.getters['guide/countRequest']
      apiGuide
        .count(countParams)
        .then(res => {
          const { data } = res
          if (data.status === 0) {
            store.dispatch('guide/setCount', data.count)
          }
        })

      const params = store.getters['guide/searchRequest']
      apiGuide
        .list(params)
        .then(res => {
          const { data } = res
          if (data.status === 0) {
            store.dispatch('guide/setLists', data.list)
          }
        })
        .finally(() => {
          store.dispatch('guide/search', false)
        })
    },
    searchReset: () => {
      store.dispatch('guide/setKeyword', '')
      store.dispatch('guide/pageReset')
      store.dispatch('guide/setCurrentId', null)

      action.load()
    }
  }

  const suggest = reactive({
    displayTip: false,
    timer: null,
    locked: false,
    lists: [],
    count: null,
    fixedCount: computed(() => {
      const string = _.isNumber(suggest.count)
        ? suggest.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : ''
      return string
    }),
    keyInput: (e) => {
      suggest.getSuggest()
      suggest.displayTip = true
    },
    getSuggest: _.throttle(async () => {
      const params = {
        keyword: state.keyword
      }

      const requestLists = []
      requestLists.push(
        apiGuide
          .count(params)
          .then(r => {
            const data = r.data
            if (data.status === 0) {
              suggest.count = data.count
            }
          }))

      await Promise.all(requestLists)
    }, 300)
  })

  return {
    action,
    state,
    suggest
  }
}
